import type * as go from 'gojs';
import type { SmartSelectRecommendedOption } from './smartSelectRecommendations';

export const nodeSmartSelectPanels = new WeakMap<go.Node, go.Part>();

export const nodeSmartSelectSelectedOptions = new WeakMap<
  go.Node,
  Map<string, SmartSelectRecommendedOption>
>();

export const nodeSmartSelectSelectedPortKeys = new WeakMap<go.Node, string>();

export const hideTimers = new WeakMap<go.Node, number>();

export const getSelectedSmartSelectPortKey = (
  node: go.Node,
  fallbackPort: go.GraphObject,
) => nodeSmartSelectSelectedPortKeys.get(node) ?? fallbackPort.portId;

export const clearTimer = (timers: WeakMap<go.Node, number>, node: go.Node) => {
  const timer = timers.get(node);

  if (timer !== undefined) {
    window.clearTimeout(timer);
    timers.delete(node);
  }
};
